export default __webpack_public_path__ + "static/media/icons-coin-green-32-px.bccce41d.svg";